import { useQuery, useQueryClient } from '@fv/client-core'
import type { TrackDetail } from '@fv/client-types'

import { shipperFetch } from '@/utils/shipperFetch'

export const trackingKeys = {
  all: ['tracking'] as const,
  load: (id: string) => [...trackingKeys.all, id] as const,
}

async function fetchTracking(loadId: string) {
  return await shipperFetch<TrackDetail>(`/shipments/${loadId}/track`)
}

export function usePrefetchTracking() {
  const queryClient = useQueryClient()

  return async (loadId: string) => {
    await queryClient.prefetchQuery({
      queryKey: trackingKeys.load(loadId),
      queryFn: () => fetchTracking(loadId),
    })
  }
}

export function useTracking(loadId: string, enabled = true) {
  return useQuery(trackingKeys.load(loadId), () => fetchTracking(loadId), {
    enabled,
  })
}
